// A set of helper functions to retrieve props for more complex claim information requests
const getPurchaseInformationProps = (purchaseInformation: any) => {
  const formFields = []

  const nestedFields = purchaseInformation.nestedFields

  for (const field of nestedFields) {
    const { id } = field
    const fields: any = {}
    field.fields.forEach((field: any, index: number) => {
      const { name, value } = field
      if (name === 'invoiceNo') {
        fields[name] = {
          valid: true,
          value: value,
          readOnly: true,
        }
        return
      }
      fields[name] = {
        id: index,
        valid: false,
        value: null,
      }
    })
    const fieldToAdd = {
      id,
      valid: false,
      fields,
    }
    formFields.push(fieldToAdd)
  }

  return {
    optionsOverride: formFields,
    showAddReceipt: false,
    showRemoveReceipt: false,
    canDelete: false,
  }
}

// Run corresponding function based on information request type
export const propStrategies: { [key: string]: Function } = {
  purchaseInformation: getPurchaseInformationProps,
}
